import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'savings-link',
  templateUrl: './savings-link.component.html',
  styleUrls: ['./savings-link.component.scss']
})
export class SavingsLinkComponent implements OnInit {

  @Input() savingsInCents: string;
  @Output() onClickThrough: EventEmitter<null> = new EventEmitter();

  constructor() { }

  ngOnInit(){ }

  goToSavingsPage(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.onClickThrough.emit();
    window.open('https://houwzer.com/sell?utm_source=listing_page', '_blank');
  }

  savingsInDollars(savingsInCents: string){
    return parseInt(savingsInCents) / 100;
  }
}
